import React, { PropTypes } from 'react';
import QuestionItem from './QuestionItem';

const NoItem = () => (
  <div className="ui message">Aucune question. Veuillez en créer une.</div>
);

const QuestionList = ({ questions, ...rest }) => {
  if (questions.length) {
    return (
      <div className="funnel">
        {questions.map(q => (
          <QuestionItem
            key={q.id}
            question={q}
            questionCount={questions.length}
            {...rest}
          />
        ))}
      </div>
    );
  }

  return <NoItem />;
};

QuestionList.propTypes = {
  questions: PropTypes.array.isRequired,
};

export default QuestionList;



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/questions/QuestionList.js